import * as CL from '@design-system/component-library';
import { useSelector } from 'react-redux';
import { dsClass } from '../../../common/constants/dsClasses.js';
import {
  emailMsg,
  invoiceDeliveryMethodMsg,
  monthMsg,
  monthlyChargeMsg,
  payerMsg,
  t,
} from '../../../common/i18n/index.js';
import { getConfiguredCommercialProducts } from '../../../common/utils/cartProductUtils.js';
import { getTotalSums } from '../../../common/utils/commercialProductUtils.js';
import { formatSum } from '../../../common/utils/priceUtils.js';
import { useAuth } from '../../../public/site/AuthProvider';
import type { BillingAccount } from '../../../generated/api/models.js';
import type { State } from '../../../selfservice/common/store.js';

import './PunchoutBillingInfo.scss';

type PunchoutBillingInfoProps = {
  personBillingAccount: BillingAccount;
  className?: string;
};

export const PunchoutBillingInfo = ({ personBillingAccount, className }: PunchoutBillingInfoProps) => {
  const { authenticatedUser } = useAuth();

  const totalMonthlyCharge = useSelector(
    (state: State) =>
      getTotalSums(getConfiguredCommercialProducts(state.deviceCheckout?.cartItems || [])).totalMonthlyRecurringCharge
  );

  return (
    <div className={`of-punchout-checkout-billing-info ${className || ''}`}>
      <h2 className={`of-sub-header ${dsClass.H2} ${dsClass.MARGIN_BOTTOM_3}`}>{t.NMNN('Oma Laitelasku details')}</h2>
      <CL.Grid>
        <CL.GridRow>
          <CL.GridCol colWidthXS={4} colWidthS={2} colWidthM={3} colWidthL={6} colWidthXL={6}>
            <div className="of-punchout-checkout-billing-info__field">
              <label>{t.PB6S(payerMsg)}</label>
              <span>
                {personBillingAccount.payerName ??
                  `${authenticatedUser?.firstName} ${authenticatedUser?.lastName ?? ''}`}
              </span>
            </div>
            <div className="of-punchout-checkout-billing-info__field">
              <label>{t.H272(invoiceDeliveryMethodMsg)}</label>
              <span>{t.OKYY(emailMsg)}</span>
              <br />
              <span>
                <em>{personBillingAccount.billReceiverEmail}</em>
              </span>
            </div>
          </CL.GridCol>
          <CL.GridCol colWidthS={6} colWidthM={1} colWidthL={6} colWidthXL={6}>
            <div className="of-punchout-checkout-billing-info__field">
              <label>{t.P0PS(monthlyChargeMsg)}</label>
              <span>{`${formatSum(totalMonthlyCharge)}/${t.XXVX(monthMsg)}`}</span>
            </div>
          </CL.GridCol>
        </CL.GridRow>
      </CL.Grid>
      <p>
        {t.BPVG(
          'Your invoice will be sent by email. You can find a copy of the invoice in Oma Elisa for personal customers, through which you can also pay the invoice if you wish.'
        )}
      </p>
    </div>
  );
};
